export class Search {
	constructor(data) {
		this.element = document.querySelector('.header__search');
		this.input = document.getElementById('search');
		this.closeBtn = document.getElementById('serch-clean');
		this.filterBtn = document.querySelector('.filter__btn');
		this.filterWrapper = document.querySelector('.filter__list-wrapper');
		this.filterOpenCheck = false;
		this.currentData = data;
		this.checkOpen = false;
		this.data = data;
		this.searchWrapper = document.querySelector('.header__search-wrapper');
		this.filterElement = document.querySelector('.filter');
		this.filtrTitle = document.querySelector('.filter__title');
		this.time = 400;
		this.closeBtnContent = document.querySelector('.popup-content__close');
		this.isMobile = window.innerWidth < 850;

		this.getMuseums();
		this.getFilterList();
		this.forMobileDevice();

		this.input.addEventListener('input', this.search.bind(this));
		this.input.addEventListener('focus', this.open.bind(this));
		this.element.addEventListener('click', this.handler.bind(this));
		this.closeBtnContent.addEventListener('click', this.close.bind(this));
		this.filterElement.addEventListener(
			'click',
			this.handlerFilter.bind(this),
		);
	}

	getMuseums(data = this.currentData) {
		const result = document.getElementById('list-result');
		const newResultwrapper = document.createElement('div');

		result.remove();
		newResultwrapper.id = 'list-result';
		newResultwrapper.classList.add('header__search-result');

		this.searchWrapper.appendChild(newResultwrapper);

		for (let i = 0; i < data.length; i++) {
			const newElement = document.createElement('div');
			newElement.id = data[i].id;
			newElement.dataset.type = data[i].type;
			newElement.classList.add('header__search-result-item');

			newElement.innerHTML = `
				<div class="header__search-result-item-name">${data[i].name}</div>
				<div class="header__search-result-item-location">${data[i].location}</div>
			`;
			newResultwrapper.appendChild(newElement);
		}
	}

	getFilterList(data = this.data) {
		const filterList = document.querySelector('.filter__list');
		const filterArray = [];

		data.forEach((element) => {
			const filter = document.createElement('input');
			const label = document.createElement('label');

			element.type.forEach((type, index) => {
				if (filterArray.indexOf(type) === -1) {
					filterArray.push(type);
					filter.type = 'radio';
					filter.name = 'filter';

					filter.id = type;
					filter.value = type;
					filter.dataset.name = element.typeName[index];

					label.htmlFor = type;
					label.innerText = element.typeName[index];
					label.classList.add('filter__item');

					filterList.appendChild(filter);
					filterList.appendChild(label);
				}
			});
		});
	}

	filter(e, data = this.data) {
		if (!e) {
			this.filtrTitle.innerText = 'все виды музеев';
			this.currentData = this.data;
			this.getMuseums();
			// this.filterClose();
			document.querySelectorAll('input[type="radio"]').forEach((elem) => {
				elem.checked = false;
			});

			return;
		}

		if (e.target.dataset.name) {
			let newData = [];
			let value = e.target.value;

			this.filtrTitle.innerText = e.target.dataset.name;

			if (value === 'all') {
				this.currentData = this.data;

				this.getMuseums();

				return;
			}

			for (let i = 0; i < data.length; i++) {
				data[i].type.forEach((type) => {
					if (type === value) {
						newData.push(data[i]);
					}
				});
			}

			this.currentData = newData;
			this.getMuseums();
		}
	}

	filterOpen(e) {
		this.filterOpenCheck = true;
		const height = e.target
			.closest('.filter')
			.querySelector('.filter__list')
			.getBoundingClientRect().height;

		this.filterElement.classList.toggle('filter-open');
		this.filterWrapper.style.height = `${height}px`;
	}

	filterClose() {
		this.filterOpenCheck = false;
		this.filterElement.classList.toggle('filter-open');
		this.filterWrapper.style.height = 0;
	}

	handlerFilter(e) {
		if (e.target.closest('.filter__list')) {
			this.filter(e);
			this.search(e);
		}

		if (this.filterOpenCheck) {
			this.filterClose(e);
		} else {
			this.filterOpen(e);
		}
	}

	search(e) {
		if (
			!e.target.classList.contains('filter__item') &&
			!this.searchWrapper.classList.contains('relative')
		) {
			this.open();
		}

		let value = this.input.value.toUpperCase();
		let result = document.getElementById('list-result');
		let elements = result.querySelectorAll('.header__search-result-item');

		for (let i = 0; i < elements.length; i++) {
			let location = elements[i].querySelector(
				'.header__search-result-item-location',
			);
			let name = elements[i].querySelector(
				'.header__search-result-item-name',
			);

			if (name) {
				let nameValue = name.textContent || name.innerText;
				let locationValue = location.textContent || location.innerText;

				if (
					nameValue.toUpperCase().includes(value) ||
					locationValue.toUpperCase().includes(value)
				) {
					elements[i].style.display = '';
				} else {
					elements[i].style.display = 'none';
				}
			}
		}

		ga('send', 'event', 'nav', 'search', this.input.value);
	}

	close() {
		if (this.checkOpen) {
			const height =
				document.querySelector('#list-result').getBoundingClientRect()
					.height +
				document.querySelector('.filter').getBoundingClientRect()
					.height;

			this.input.value = '';
			this.searchWrapper.style.overflow = 'hidden';
			this.checkOpen = false;
			this.searchWrapper.style.height = `${height}px`;
			this.searchWrapper.style.zIndex = 20;

			setTimeout(() => {
				this.searchWrapper.style.height = 0;
			}, this.time);

			this.toggleClassClose();
			if (!this.isMobile) {
				this.clearList();
			}
		}
	}

	open() {
		if (!this.checkOpen) {
			const height =
				document.querySelector('#list-result').getBoundingClientRect()
					.height +
				document.querySelector('.filter').getBoundingClientRect()
					.height;

			this.checkOpen = true;
			this.searchWrapper.style.height = `${height}px`;
			this.searchWrapper.style.zIndex = 21;

			setTimeout(() => {
				this.searchWrapper.style.overflow = 'auto';
				this.searchWrapper.style.height = 'auto';
			}, this.time);

			this.toggleClassOpen();
		}
	}

	toggleClassOpen() {
		if (this.isMobile) {
			if (
				this.element.classList.contains('header__search_content-active')
			) {
				this.element.classList.add(
					'header__search_content-active_open',
				);
				document
					.querySelector('.header__search-wrapper')
					.classList.add('fixed');
				document
					.querySelector('.header__search-wrapper')
					.classList.remove('relative');

				const height =
					document
						.querySelector('#list-result')
						.getBoundingClientRect().height +
					document.querySelector('.filter').getBoundingClientRect()
						.height;
				this.searchWrapper.style.height = `${height}px`;
			}
		}
	}

	toggleClassClose() {
		if (this.isMobile) {
			if (
				this.element.classList.contains(
					'header__search_content-active_open',
				)
			) {
				this.element.classList.remove(
					'header__search_content-active_open',
				);
				document
					.querySelector('.header__search-wrapper')
					.classList.add('relative');
				document
					.querySelector('.header__search-wrapper')
					.classList.remove('fixed');

				this.searchWrapper.style.height = 0;
			}
		}
	}

	clean() {
		this.close();
	}

	handler(e) {
		if (e.target.closest('.header__search-clean')) {
			this.clean();
		}
	}

	clickSearch(e) {
		let target = e.target;
		let value = target.id;
		let locationName = target.dataset.name;

		if (e.target.closest('.popup-list__item')) {
			const parent = e.target.closest('.popup-list__item');

			target = parent;
			value = parent.dataset.location;
			locationName = parent.dataset.locationName;
		}

		let listResult = document.querySelectorAll(
			'.header__search-result-item',
		);
		let id = 0;

		switch (value) {
			case "primorsky-krai":
				value = "vladivostok";
				break;
			case "ru-kr-obl":
				value = "ru-kr";
				break;
			case "krym":
				value = "sevastopol";
				break;
			case "tatarstan":
				value = "tatarstan-kazan";
				break;
			case "kbr":
				value = "kbr-nalchik";
				break;
			case "mordoviya":
				value = "saransk";
				break;
			case "hmao":
				value = "hmao-kogalym";
				break;
			default:
				break;
		}

		this.input.value = locationName;

		if (this.isMobile) {
			this.searchRegionForMobile(value);
		} else {
			this.searchRegion(value);
		}

		for (let i = 0; i < listResult.length; i++) {
			if (listResult[i].style.display === '') {
				id = listResult[i].id;
				break;
			}
		}

		return id;
	}

	forMobileDevice() {
		if (this.isMobile) {
			const footer = document.querySelector('.footer');
			const searchResultList = this.searchWrapper;

			footer.before(searchResultList);
		}
	}

	searchRegion(value) {
		this.open();

		let valueRegion = value.split('-')[0];
		let result = document.getElementById('list-result');
		let elements = result.querySelectorAll('.header__search-result-item');

		for (let i = 0; i < elements.length; i++) {
			let location = this.data[elements[i].id].locationId.split('-')[0];

			if (location === valueRegion) {
				elements[i].style.display = '';
			} else {
				elements[i].style.display = 'none';
			}
		}
	}

	searchRegionForMobile(value) {
		this.open();

		let valueRegion = value.split('-')[0];
		let result = document.getElementById('list-result');
		let elements = result.querySelectorAll('.header__search-result-item');

		if (value.split('-').length === 3) {
			valueRegion = value.split('-')[2];
		}

		for (let i = 0; i < elements.length; i++) {
			let location = this.data[elements[i].id].locationId.split('-')[0];

			if (value.split('-').length === 3) {
				location = this.data[elements[i].id].locationId.split('-')[2];
			}
			if (value.split('-').length === 1) {
				location = this.data[elements[i].id].locationId;
			}
			if (location === valueRegion) {
				elements[i].style.display = '';
			} else {
				elements[i].style.display = 'none';
			}
		}
	}

	clearList() {
		let listResult = document.querySelectorAll(
			'.header__search-result-item',
		);

		for (let i = 0; i < listResult.length; i++) {
			if (listResult[i].style.display === 'none') {
				listResult[i].style.display = '';
			}
		}
	}
}
